module.exports = __webpack_public_path__ + "static/media/landingpage.c1c9fbe2.png";